import Pages from "../Container/Loginpage.jsx";
import ProfilePage from "../Container/ProfilePage.jsx"

var indexRoutes = [
  {path:"/profilepage", name:"ProfilePage", component: ProfilePage},
  { path: "/loginpage", name: "LoginPage", component: Pages },
  { redirect:true, path:"/" , pathTo:"/loginpage" , name:"LoginPage" }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx